/**
 * Sage Intacct Journal to Snowflake – sync flow handler.
 * Calls backend: POST .../synctrack/sage/journal-to-sf?sflId=...&tenantId=...&sfDatabase=...
 * sfDatabase is read from flow parameters (sync-flow-properties by master flow ID).
 */

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}synctrack/sage/journal-to-sf`;
const FLOW_PARAMS_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/sync-flow-properties`;

export const handleSageIntacctJournalToSnowflakeFlow = async (syncFlow, masterConnectors) => {
  try {
    const token = localStorage.getItem('token');
    const sflId = syncFlow.instanceId || syncFlow.sfiId;
    const tenantId = localStorage.getItem('tenantId');
    const masterFlowId = syncFlow.sfl_mf_id;

    if (!sflId) {
      throw new Error('Flow instance ID (sflId) is missing in syncFlow object');
    }
    if (!tenantId) {
      throw new Error('tenantId is missing. Ensure you are logged in.');
    }

    // Get sfDatabase and optional snowflakeBatchSize from flow parameters (same as Parameters drawer)
    let sfDatabase =
      syncFlow.sfDatabase ||
      syncFlow.sfiSfDatabase ||
      syncFlow.parameters?.sfDatabase;
    let snowflakeBatchSize = syncFlow.parameters?.snowflakeBatchSize ?? syncFlow.parameters?.SnowflakeBatchSize ?? null;
    if (masterFlowId) {
      const paramsRes = await fetch(`${FLOW_PARAMS_URL}/${masterFlowId}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (paramsRes.ok) {
        const flowParams = await paramsRes.json();
        if (Array.isArray(flowParams)) {
          if (!sfDatabase) {
            const p = flowParams.find(
              (x) =>
                (x.sfpName || x.mfpName || x.name || '').toLowerCase() === 'sfdatabase' ||
                (x.sfpName || x.mfpName || x.name || '') === 'sf_database'
            );
            sfDatabase = p?.sfpValue ?? p?.mfpValue ?? p?.value ?? null;
          }
          const batchParam = flowParams.find(
            (x) =>
              (x.sfpName || x.mfpName || x.name || '').toLowerCase() === 'snowflakebatchsize'
          );
          if (batchParam) {
            const v = batchParam.sfpValue ?? batchParam.mfpValue ?? batchParam.value;
            if (v != null && v !== '') {
              const num = parseInt(String(v).trim(), 10);
              if (!Number.isNaN(num) && num > 0) snowflakeBatchSize = num;
            }
          }
        }
      }
    }

    if (!sfDatabase) {
      throw new Error(
        'sfDatabase is required. Add it in the flow Parameters (e.g. sfDatabase = DEV_T_108).'
      );
    }

    const params = new URLSearchParams({
      sflId,
      tenantId,
      sfDatabase,
    });
    if (snowflakeBatchSize != null && snowflakeBatchSize > 0) {
      params.set('snowflakeBatchSize', String(snowflakeBatchSize));
    }
    const url = `${API_BASE}?${params.toString()}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `API Error: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in Sage Intacct Journal to Snowflake flow:', error);
    throw error;
  }
};
